// The scanner screens' key recipes (Scanner/), which are phone-width kiosk keys
// and not yet on the kit, plus the focus ring StockCard's hand-built rows carry.
// Everywhere else a key is ui/Button.

export const FOCUS =
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-surface';
export const MOTION = 'transition-colors duration-150 ease-emphasized motion-reduce:transition-none';
// A state layer, not a second fill: the tonal key already sits on the top
// surface step, so hover composites a light overlay over whatever fill it has.
export const STATE_LAYER = 'hover:bg-[linear-gradient(rgb(255_255_255/0.07),rgb(255_255_255/0.07))]';
export const BTN_TONAL = `inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-surface-container-highest px-4 py-2 text-sm font-medium text-on-surface ${STATE_LAYER} disabled:opacity-40 ${FOCUS} ${MOTION}`;
